import type { GTMEventReturnType } from '../GTM.types';
import GTMBaseModel from '../GTMBaseModel';

interface GTMDetailSelectOptionsModelReturnType extends GTMEventReturnType {
    fixed_date_arrival?: string;
    fixed_date_departure?: string;
    custom_adults?: number;
    custom_children?: number;
    custom_babies?: number;
    custom_pets?: number;
}

interface GTMDetailSelectOptionsModelData {
    arrivalDate?: string;
    departureDate?: string;
    adults?: number;
    children?: number;
    babies?: number;
    pets?: number;
}

export default class GTMDetailSelectOptionsModel extends GTMBaseModel {
    public static parseToGTMData({
        arrivalDate,
        departureDate,
        adults,
        children,
        babies,
        pets
    }: GTMDetailSelectOptionsModelData): GTMDetailSelectOptionsModelReturnType {
        return {
            ...GTMBaseModel.getBaseData(),
            ga4_property: 'cro_event',
            ga4_event_name: 'detail_select_options',
            fixed_date_arrival: arrivalDate,
            fixed_date_departure: departureDate,
            custom_adults: adults,
            custom_children: children,
            custom_babies: babies,
            custom_pets: pets
        };
    }
}
